/**
 * @module explore/components/creatives_page
 */
import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import CreativeTile from 'explore/components/creative_tile';
import GalleryNoResults from 'common/components/gallery_no_results';
import { LoadingIndicator } from 'common/components/preloader';

/**
 * Component rendering list of creatives
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const CreativesPage = (props) => {
  if (props.fetching) {
    return (
      <div className="small-16 large-12 columns explore-creatives">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="small-16 large-12 columns explore-creatives">
      { props.creatives.length ?
        props.creatives.map(creative => (
          <CreativeTile
            creative={creative}
            authenticated={props.user.logged_in}
            userType={props.user.profile_data ? props.user.profile_data.user_type : 'Anonymous'}
            key={v4()}
          />
        ))
        : <GalleryNoResults />
      }
    </div>
  );
};

CreativesPage.propTypes = {
  creatives: PropTypes.array,
  fetching: PropTypes.bool,
  user: PropTypes.object,
};

export default CreativesPage;



// WEBPACK FOOTER //
// ./explore/components/creatives_page.jsx